import { render, staticRenderFns } from "./backgroundit.vue?vue&type=template&id=8ecd6504&scoped=true&"
import script from "./backgroundit.vue?vue&type=script&lang=js&"
export * from "./backgroundit.vue?vue&type=script&lang=js&"
import style0 from "./backgroundit.vue?vue&type=style&index=0&id=8ecd6504&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ecd6504",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VParallax } from 'vuetify/lib/components/VParallax';
installComponents(component, {VBtn,VImg,VParallax})
